export default __webpack_public_path__ + "static/media/ApparentPowerImg.6db08120.svg";